import { fetcher } from '@commenda/utils';

export interface AdminSetComplianceTypeVisibilityArgs {
  // filingCompositeId = ObligationRules.compositeId = ComplianceItem.type
  filingCompositeId: string;
  hidden: boolean;
}

/** Sets a compliance type's global show/hide state. Admin-only (guarded server-side). Throws on failure. */
export async function setAdminComplianceTypeVisibility(args: AdminSetComplianceTypeVisibilityArgs): Promise<void> {
  const response = await fetcher('compliance-type-visibility', {
    method: 'POST',
    body: args,
  });

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { message?: unknown } | null;
    const message = typeof body?.message === 'string' ? body.message : 'Failed to update compliance type visibility';
    throw new Error(message);
  }
}
